import { render, staticRenderFns } from "./ListRequestLetterTaghirAghsat.vue?vue&type=template&id=39afdaaa&scoped=true&"
import script from "./ListRequestLetterTaghirAghsat.vue?vue&type=script&lang=js&"
export * from "./ListRequestLetterTaghirAghsat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39afdaaa",
  null
  
)

export default component.exports